import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AccessRestricted from '../pages/AccessRestricted';

export function ProtectedRoute({ children, requiredRole, requiredPermission }) {
  const { user, loading, hasRole, hasPermission, isAdmin, isOperator } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-teal" />
      </div>
    );
  }

  // Not logged in - redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check role requirement
  if (requiredRole) {
    const allowedRoles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
    if (!hasRole(...allowedRoles)) {
      return <AccessRestricted />;
    }
  }

  // Check permission requirement
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <AccessRestricted />;
  }

  return children;
}

// Shorthand components for common cases
export function AdminRoute({ children }) {
  return (
    <ProtectedRoute requiredRole="admin">
      {children}
    </ProtectedRoute>
  );
}

export function OperatorRoute({ children }) {
  return (
    <ProtectedRoute requiredRole={['admin', 'operator']}>
      {children}
    </ProtectedRoute>
  );
}

export function AuthRoute({ children }) {
  return (
    <ProtectedRoute>
      {children}
    </ProtectedRoute>
  );
}
